module.exports = __webpack_public_path__ + "img/pr3.479e871b.jpg";